<ng-container *ngIf="!(cmsService.loaded$ | async)">
    <p class="loading">Loading <span>.</span><span>.</span><span>.</span></p>
</ng-container>
<ng-container *ngIf="cmsService.loaded$ | async">
    <app-menu></app-menu>
    <main class="flex-shrink-0">
        <router-outlet></router-outlet>
    </main>
    <app-footer class="footer mt-auto"></app-footer>
    <app-cms-keys-bar></app-cms-keys-bar>
</ng-container>
